/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Neuro_RehabInputs */

const en_service_type_neuro_rehab = /** @type {(inputs: Service_Type_Neuro_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neurological rehab`)
};

const pl_service_type_neuro_rehab = /** @type {(inputs: Service_Type_Neuro_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehabilitacja neurologiczna`)
};

/**
* | output |
* | --- |
* | "Neurological rehab" |
*
* @param {Service_Type_Neuro_RehabInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_neuro_rehab = /** @type {((inputs?: Service_Type_Neuro_RehabInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Neuro_RehabInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_neuro_rehab(inputs)
	return en_service_type_neuro_rehab(inputs)
});